import { styled } from "@mui/material/styles";
import { Grid2, Stack, Typography } from "@mui/material";
import { colors, fonts } from "../../../../theme/theme";

export const IntroText = styled(Typography)(({ theme }) => ({
  color: colors.primary,
  fontFamily: fonts.quicksand,
  fontSize: "18px",
  fontWeight: 400,
  lineHeight: 1.6,
  marginTop: theme.spacing(3),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const GridContainer = styled(Grid2)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

export const MiddleParagraph = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.quicksand,
  fontSize: "18px",
  color: colors.primary,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const StudySectionStack = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  marginBottom: theme.spacing(4),
  flexDirection: "row",
  gap: theme.spacing(2),
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    justifyContent: "center",
  },
}));

export const StudyImage = styled("img")(({ theme }) => ({
  width: "550px",
  height: "100%",
  cursor: "pointer",
  marginTop: 0,
  borderRadius: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    marginTop: "20px",
  },
}));

export const StudyTitle = styled(Typography)(({ theme }) => ({
  fontSize: "20px",
  fontFamily: fonts.gotham,
  color: colors.primary,
  [theme.breakpoints.down("md")]: {
    fontSize: "18px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(2),
  },
}));

export const StudyLinkStack = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  gap: theme.spacing(1),
}));
